import { type FC, useEffect, useRef, useState } from 'react'
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react'
import { type Swiper } from 'swiper/types'
import { analytics } from '../../../utils/analytics'

import type { VisualElement } from '../../../store/reducers/sessionReducer'
import { ScreenshotItem } from './ScreenshotItem'

interface ScreenshotPanelProps {
  visualData: VisualElement[]
}

const ScreenshotPanel: FC<ScreenshotPanelProps> = ({ visualData }) => {
  const sliderRef = useRef<Swiper>(null)

  const [showsPanel, setShowPanel] = useState(true)
  const [currentSlide, setCurrentSlide] = useState(0)

  const onNextClick = () => sliderRef?.current?.slideNext()
  const onPrevClick = () => sliderRef?.current?.slidePrev()
  const setSwiperRef = (swiper: Swiper) => {
    sliderRef.current = swiper
  }
  const handleClosesPanel = () => {
    setCurrentSlide(0)
    setShowPanel(false)
    analytics.logEvent('watch_session_visual_card_closed')
  }

  useEffect(() => {
    setShowPanel(true)
  }, [visualData])

  if (!showsPanel) {
    return null
  }

  return (
    <div className="fixed right-16 min-[765px]:right-24 bottom-[135px] md:bottom-[140px] xl3:bottom-[50px] z-50 mr-2 rounded-[16px] overflow-hidden tc-mv-blur w-[300px] min-[765px]:w-[320px] screenshot-panel">
      <button
        className="absolute top-3 right-4 text-white z-10"
        onClick={handleClosesPanel}
      >
        <i className="fa fa-close text-xl" />
      </button>
      <SwiperComponent
        slidesPerView={1}
        onSwiper={setSwiperRef}
        onSlideChange={swiper => setCurrentSlide(swiper.activeIndex)}
        autoHeight
      >
        {visualData.map(({ title, url, previewUrl }, index) => (
          <SwiperSlide key={index}>
            <ScreenshotItem title={title} url={url} previewUrl={previewUrl} />
          </SwiperSlide>
        ))}
      </SwiperComponent>
      {currentSlide !== 0 && (
        <button
          className="absolute bottom-[4px] md:bottom-[14px] left-2 w-10 h-10 flex items-center justify-center z-10"
          onClick={onPrevClick}
        >
          <i className="fa fa-angle-left text-white" />
        </button>
      )}

      {currentSlide !== (visualData?.length || 0) - 1 && (
        <button
          className="absolute bottom-[4px] md:bottom-[14px] right-2 w-10 h-10 flex items-center justify-center z-10"
          onClick={onNextClick}
        >
          <i className="fa fa-angle-right text-white" />
        </button>
      )}
    </div>
  )
}

export { ScreenshotPanel }
